import "core-js/modules/es.reflect.construct.js";
import _toArray from "@babel/runtime/helpers/toArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.trim.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var PostalCodeAutoComplete = /*#__PURE__*/function (_lm$Composant) {
  function PostalCodeAutoComplete() {
    var _this;
    _classCallCheck(this, PostalCodeAutoComplete);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PostalCodeAutoComplete, [].concat(args));
    _defineProperty(_this, "postalCodeSuggestions", []);
    _defineProperty(_this, "inputPostalCodeElement", document.querySelector('.js-postal-code-city'));
    _defineProperty(_this, "suggestionElement", document.querySelector('.js-postal-code-suggestions'));
    _defineProperty(_this, "postalCodeHidden", document.querySelector('#postalCode'));
    _defineProperty(_this, "cityHidden", document.querySelector('#cityPostalCode'));
    _defineProperty(_this, "inputPostalCode", _this.inputPostalCodeElement.getElementsByClassName('js-form-input')[0]);
    return _this;
  }
  _inherits(PostalCodeAutoComplete, _lm$Composant);
  return _createClass(PostalCodeAutoComplete, [{
    key: "createSearchCity",
    value: function createSearchCity(addressCity, index) {
      this.suggestionElement.classList.add('mc-listbox');
      this.suggestionElement.setAttribute('data-cerberus', 'UL_postalCode');
      var searchCity = document.createElement('li');
      searchCity.classList.add('mc-listbox__tile');
      searchCity.setAttribute('data-cerberus', "LI_postalCode_".concat(addressCity.postalCode));
      var cityLabel = document.createElement('label');
      cityLabel.textContent = addressCity.address;
      cityLabel.classList.add('mc-list__label');
      cityLabel.setAttribute('for', "postalCodeSuggestion".concat(index));
      var cityInput = document.createElement('input');
      cityInput.classList.add('mc-listbox__input');
      cityInput.setAttribute('type', 'radio');
      cityInput.setAttribute('name', 'postalCodeSuggestion');
      cityInput.setAttribute('value', addressCity.address);
      cityInput.setAttribute('id', "postalCodeSuggestion".concat(index));
      searchCity.appendChild(cityInput);
      searchCity.appendChild(cityLabel);
      return searchCity;
    }
  }, {
    key: "clearSuggestions",
    value: function clearSuggestions() {
      var suggestionElement = this.suggestionElement;
      suggestionElement.innerHTML = '';
      suggestionElement.classList.remove('mc-listbox');
    }
  }, {
    key: "hidePostalCodeInputError",
    value: function hidePostalCodeInputError() {
      var errorElement = this.inputPostalCodeElement.getElementsByClassName('js-form-error')[0];
      if (errorElement) {
        errorElement.style = 'display: none';
      }
    }
  }, {
    key: "showPostalCodeInputError",
    value: function showPostalCodeInputError() {
      var errorElement = this.inputPostalCodeElement.getElementsByClassName('js-form-error')[0];
      if (errorElement) {
        errorElement.style = 'display: block';
      }
    }
  }, {
    key: "suggestionCityBrowsing",
    value: function suggestionCityBrowsing() {
      this.inputPostalCode.classList.remove('is-invalid');
      this.inputPostalCode.classList.add('is-valid');
      this.hidePostalCodeInputError();
      if (!this.hasStartedBrowsing) {
        this.hasStartedBrowsing = true;
        this.userTypedInPostalCode = this.inputPostalCode.value;
      }
    }
  }, {
    key: "suggestionCitySelected",
    value: function suggestionCitySelected() {
      this.clearSuggestions();
      this.hasStartedBrowsing = false;
      this.userTypedInPostalCode = '';
      this.inputPostalCode.focus();
      this.showPostalCodeInputError();
    }
  }, {
    key: "suggestionCityAbort",
    value: function suggestionCityAbort() {
      this.inputPostalCode.value = this.userTypedInPostalCode;
      this.hasStartedBrowsing = false;
      this.clearSuggestions();
      this.inputPostalCode.focus();
      this.showPostalCodeInputError();
    }
  }, {
    key: "assignCity",
    value: function assignCity(suggestionCity) {
      this.inputPostalCode.value = suggestionCity.address;
      this.postalCodeHidden.value = suggestionCity.postalCode;
      this.cityHidden.value = suggestionCity.city;
    }
  }, {
    key: "renderSuggestionsCity",
    value: function renderSuggestionsCity(suggestionsCityList) {
      var _this2 = this;
      this.clearSuggestions();
      suggestionsCityList.map(function (suggestionCity, index) {
        var searchCity = _this2.createSearchCity(suggestionCity, index);
        searchCity.addEventListener('keydown', function (event) {
          if (event.code === 'ArrowDown') {
            _this2.suggestionCityBrowsing();
            _this2.assignCity(suggestionsCityList[(index + 1) % suggestionsCityList.length]);
          } else if (event.code === 'ArrowUp') {
            _this2.suggestionCityBrowsing();
            _this2.assignCity(suggestionsCityList[(index - 1 + 5) % suggestionsCityList.length]);
          }
        });
        searchCity.addEventListener('keyup', function (event) {
          if (event.code === 'Enter' || event.code === 'Space') {
            _this2.assignCity(suggestionCity);
            _this2.suggestionCitySelected();
          }
        });
        searchCity.addEventListener('mousedown', function () {
          _this2.assignCity(suggestionCity);
          _this2.suggestionCitySelected();
        });
        _this2.suggestionElement.appendChild(searchCity);
      });
    }
  }, {
    key: "handleDownArrow",
    value: function handleDownArrow(event) {
      event.preventDefault();
      var firstAddress = document.querySelector('input[name=\'postalCodeSuggestion\']');
      firstAddress.focus();
      this.suggestionCityBrowsing();
      var addressInformation = this.postalCodeSuggestions.filter(function (postalCode) {
        return postalCode.address === firstAddress.value;
      });
      this.assignCity(addressInformation[0]);
    }
  }, {
    key: "handleAutoSuggestions",
    value: function handleAutoSuggestions(event) {
      var _this3 = this;
      var search = event.target.value;
      var isSearchValid = /^[A-Za-zÀ-ÿ0-9_\-,żźćńółęąśŻŹĆĄŚĘŁÓŃ' ]*$/gi.test(search) && !(search === '');
      if (!isSearchValid) {
        return;
      }
      lm.fetch({
        url: "/services/postalCode/".concat(search),
        method: 'GET',
        success: function success(rawSuggestions) {
          var suggestions = JSON.parse(rawSuggestions);
          var noDuplicateSuggestions = suggestions.reduce(function (accumulator, current) {
            var sameCity = accumulator.find(function (addressCity) {
              return addressCity.address === current.address;
            });
            if (!sameCity) {
              accumulator.push(current);
            }
            return accumulator;
          }, []);
          _this3.postalCodeSuggestions = noDuplicateSuggestions;
          _this3.renderSuggestionsCity(noDuplicateSuggestions);
        }
      });
    }
  }, {
    key: "manualInput",
    value: function manualInput(inputValue) {
      var _inputValue$split = inputValue.split(' '),
        _inputValue$split2 = _toArray(_inputValue$split),
        postalCode = _inputValue$split2[0],
        city = _arrayLikeToArray(_inputValue$split2).slice(1);
      var cityJoin = city.join(' ');
      var suggestionCity = {
        address: inputValue,
        postalCode: postalCode,
        city: cityJoin
      };
      this.assignCity(suggestionCity);
    }
  }, {
    key: "initPostalCode",
    value: function initPostalCode() {
      var _this4 = this;
      this.userTypedInPostalCode = '';
      this.hasStartedBrowsing = false;
      document.addEventListener('mouseup', function (event) {
        if (!_this4.suggestionElement.contains(event.target)) {
          _this4.clearSuggestions();
        }
      });
      this.suggestionElement.addEventListener('keyup', function (event) {
        if (event.code === 'Escape') {
          _this4.suggestionCityAbort();
        }
      });
      this.inputPostalCodeElement.addEventListener('keyup', function (event) {
        var value = event.target.value;
        var searchValid = false;
        if (/^\d{5}/.test(value)) {
          if (value.length === 5) {
            searchValid = true;
          } else if (/\s/.test(value[5])) {
            var cityPart = value.substring(5).trim();
            var cityRegex = /^[ _,'\-a-z\u00C0-\u024F\u1E00-\u1EFF]*$/gi;
            searchValid = cityRegex.test(cityPart);
          }
        }
        if (searchValid) {
          _this4.manualInput(value);
        } else if (event.code === 'Escape') {
          _this4.suggestionCityAbort();
        } else if (event.code === 'ArrowDown' && _this4.postalCodeSuggestions.length) {
          _this4.handleDownArrow(event);
        } else {
          _this4.handleAutoSuggestions(event);
        }
      });
    }
  }]);
}(lm.Composant);